export default {
  available_bests: [],
  user_bests: [],
  history: [],
  symbols_data: [],
};
